@if (contactsData$ | async; as contactsData) {
  <div
    class="profile-contacts"
    [ngClass]="{ revealed: contactsOpened }"
    [class.empty]="numberOfContacts === 0 && !searchRequestIsPending && lockSearchMore">
    <div class="profile-contacts__content">
      @if (this.someContactsHidden) {
        <app-hidden-candidate-contacts
          [contactsData]="contactsData"></app-hidden-candidate-contacts>
      } @else {
        <app-revealed-candidate-contacts
          [contactsInfoMap]="contactsData"></app-revealed-candidate-contacts>
      }
    </div>
    <div class="profile-contacts__side-block">
      @if (someContactsHidden) {
        <div class="wrapper">
          <button class="btn" [class.disabled]="lockOpenContacts" (click)="openContacts()">
            <span class="text btn__text">
              {{ numberOfContacts | currentNumeric: 'OPEN_CONTACTS' | translate }}
            </span>
          </button>
        </div>
      } @else {
        @if (searchRequestIsPending || !lockSearchMore) {
          <div class="wrapper">
            <button
              [class.invicible]="searchRequestIsPending"
              class="btn"
              [disabled]="searchRequestIsPending"
              (click)="searchMoreContacts()">
              <span class="text btn__text">
                @if (numberOfContacts === 0) {
                  {{ 'CANDIDATE.CONTACTS.SEARCH_CONTACTS' | translate }}
                }
                @if (numberOfContacts > 0) {
                  {{ 'CANDIDATE.CONTACTS.SEARCH_MORE_CONTACTS' | translate }}
                }
              </span>
            </button>
            @if (searchRequestIsPending) {
              <app-loading-animation class="loader-animation"></app-loading-animation>
            }
          </div>
        }
      }
    </div>
  </div>
}
